import { render, staticRenderFns } from "./CheckboxWithMenu.vue?vue&type=template&id=3ddc5e60&scoped=true"
import script from "./CheckboxWithMenu.vue?vue&type=script&lang=js"
export * from "./CheckboxWithMenu.vue?vue&type=script&lang=js"
import style0 from "./CheckboxWithMenu.vue?vue&type=style&index=0&id=3ddc5e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc5e60",
  null
  
)

export default component.exports